const mapping: Record<
  string,
  (lambdaParameter: string, value: any, otherValues: any) => string | null
> = {
  description: (lambdaParameter, value) =>
    `${lambdaParameter}.Description.Contains("${value}")`,
  jsonStatusPropertyPath: (lambdaParameter, value) =>
    `${lambdaParameter}.JsonStatusPropertyPath.Contains("${value}")`,
  comparisonValue: (lambdaParameter, value) =>
    `${lambdaParameter}.ComparisonValue.Contains("${value}")`,
  notificationCategoryId: (lambdaParameter, value) =>
    `${lambdaParameter}.NotificationCategoryId==${value}`,
  jsonStatusPropertyComparisonType: (lambdaParameter, value) =>
    `${lambdaParameter}.JsonStatusPropertyComparisonType==${value}`,
}

export const filterMapper = (key: string) =>
  mapping[key] as (
    lambdaParameter: string,
    value: any,
    otherValues: any,
  ) => string

export default filterMapper
